
<div *ngIf="!!items.length" class="se-side-search-button-container">
    <button *ngIf="!!items.length && EnableAllBusinessUnitExaminationSearch"
            (click)="reLoadEprEventsRequired()"
            class="se-button-no-ripple se-flex-1"
            color="primary"
            mat-button
            matTooltip="{{'AllBusinessUnitSearch' | translate}}"
            matTooltipShowDelay="500">
        <mat-icon class="search-filter-search-icon">search</mat-icon>
    </button>
</div>
<div class="se-side-patient-history-container">

    <div class="se-side-patient-history-items-container" *ngIf="!!items.length">
        <div *ngFor="let item of items" class="items-inner-container">
            <se-side-patient-history-item [item]="item"
                                          (historySelectionChanged)="onHistorySelectionChanged($event)">

            </se-side-patient-history-item>
        </div>
    </div>

    <div class="estensa-spinner" *ngIf="isLoading | async">
        <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="!!!items.length" class="se-side-patient-history-text-container">
        <span>{{patientHistoryMessage}}</span>
    </div>
</div>
